import { Inject, Provided } from '@denishussar/html5-game-engine';
import { OKSocialService } from './Implementations/OKSocialService';
import { AbstractSocialService } from './Implementations/AbstractSocialService';
import { VKSocialService } from './Implementations/VKSocialService';
import { EmptySocialService } from './Implementations/EmptySocialServeice';

export enum SocialEnum {
    Empty = 'Empty',
    VK = 'VK',
    OK = 'OK',
}

const socialCheckConditions = new Map([
    [SocialEnum.VK, window.location.href.indexOf('vk.com') >= 0],
    [SocialEnum.OK, window.location.href.indexOf('ok.ru') >= 0],
    [SocialEnum.Empty, true],
]);

class SocialProvider {
    @Inject private vkSocialService: VKSocialService;
    @Inject private okSocialService: OKSocialService;
    @Inject private emptySocialService: EmptySocialService;

    get() {
        let currentSocial: SocialEnum;
        socialCheckConditions.forEach((value, key) => currentSocial = value ? key : currentSocial);

        switch (currentSocial) {
            case SocialEnum.VK:
                return this.vkSocialService;
            case SocialEnum.OK:
                return this.okSocialService;
            default:
                return this.emptySocialService; //todo: empty social service;
        }
    }
}

const socialProvider = new SocialProvider();

@Provided(socialProvider) //@ts-ignore
export class SocialService extends AbstractSocialService {}
